module.exports = __webpack_public_path__ + "static/media/exista-vaccin-sau-tratament.a0d32c66.jpeg";